<template>
  <div class="navbar">
    <div class="left">
      <img src="@/assets/logo.png" alt="" />
      <span class="name">加练管理平台</span>
    </div>
    <div class="right-menu">
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <!-- <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar" /> -->
          <div class="avatar-wrapper-box">Hi, {{userName}}</div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <router-link to="/personalContent">
            <el-dropdown-item>
              {{ $t("navbar.dashboard") }}
            </el-dropdown-item>
          </router-link> -->
          <el-dropdown-item divided>
            <span style="display: block" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeToken } from "@/utils/auth";
import { logout } from "@/api/login";

export default {
  data(){
    return {
      userName: null
    }
  },
  computed: {
    ...mapGetters(["sidebar", "name", "avatar", "device"]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    logout() {
      // this.$store.commit("SET_TOKEN", "");
      // this.$store.commit("SET_ROLES", []);
      logout().then(res => {
        removeToken();
        location.reload();
        localStorage.clear()
      })
    },
  },
  created(){
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    if(userInfo){
      this.userName = userInfo.userName;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(90deg, #ba4135 0%, #ca4739 100%);
  color: #fff;
  .left {
    margin-left: 24px;
    display: flex;
    align-items: center;
    img {
      width: 80px;
      height: 22px;
      margin-right: 24px;
    }
    .name {
      font-family: "PingFang SC";
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
    }
  }

  .right-menu {
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      // color: #5a5e66;
      vertical-align: text-bottom;
      color: #fff;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
